import { BrandIdentityGuideSchema } from "@redotech/redo-model/agents/aeo-agents/brand-identity-guide";
import * as z from "zod/v4";

export const getBrandIdentityGuide = {
  name: "getBrandIdentityGuide" as const,
  input: z.object({}),
  output: BrandIdentityGuideSchema.nullable(),
};
